const env = {
  version: import.meta.env.VITE_APP_VERSION,
  gitSha: import.meta.env.VITE_APP_GIT_SHA,
  gitBranch: import.meta.env.VITE_APP_GIT_BRANCH,
  siteTitle: import.meta.env.VITE_APP_SITE_TITLE,
  siteSubTitle: import.meta.env.VITE_APP_SITE_SUB_TITLE,
  backendBaseUrl: import.meta.env.VITE_APP_BACKEND_BASE_URL,
};

export default env;
